(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/triss-subscription/assets/javascripts/widget.js') >= 0) return;  svs.modules.push('/modules/triss-subscription/assets/javascripts/widget.js');
"use strict";

setGlobal('svs.trissSubscription.Widget', _ref => {
  let {
    Fallback,
    name
  } = _ref;
  const widget = Handlebars.helpers.widgetArea({
    hash: {
      name
    }
  });
  return React.createElement("div", null, widget ? React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: widget.string
    }
  }) : React.createElement(Fallback, null));
});

 })(window);